/** Trims a supplier address down to "City, Country" for card subtitles —
 * the full street address is detail-page information and truncates badly
 * in a card. ETG returns free-text addresses with no structured city
 * field on the search response, so this reads the last two segments. */
export function cityCountryOf(address: string): string {
  const parts = address
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
  return parts.slice(-2).join(', ') || address;
}

const STREET_HINT = /\b(street|st|avenue|ave|road|rd|boulevard|blvd|lane|ln|drive|dr|court|ct|way|highway|hwy|route|rte|suite|ste|floor|fl|unit|apt|block|no)\b\.?/i;

/** A short neighbourhood/city label for result cards, in place of the full
 * street address (which is detail-page information and truncates badly). ETG
 * addresses are free text with no structured fields, so we read positionally:
 * a leading house-number / street-type segment is dropped, then we keep the
 * last two remaining segments (neighbourhood + city, or city + country). This
 * never surfaces a street line, and falls back to city + country. */
export function areaLabel(address: string): string {
  let parts = address
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
  if (parts.length > 1 && (/^\d/.test(parts[0]) || STREET_HINT.test(parts[0]))) {
    parts = parts.slice(1);
  }
  return parts.slice(-2).join(', ') || cityCountryOf(address);
}
